import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";
import { Build, Job } from "~/components/build/Show/lib/types";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";
import { setJobQueryData } from "~/components/build/Show/lib/queries/job";

type FetchBuildJobResponse = { job: Job; jobWithRetries: Job[] };

export const jobDrawerQueryKey = (build: Build, jobUuid: Job["id"]) => {
  return ["build", build.id, "jobs", jobUuid, "job-drawer"];
};

export const jobDrawerQueryOptions = (
  build: Build,
  jobUuid: Job["id"],
  queryOptionsArgs: Omit<UseQueryOptions<FetchBuildJobResponse>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: jobDrawerQueryKey(build, jobUuid),
    queryFn: ({ client: queryClient, signal }) =>
      fetchJobDrawer(build.buildDataBasePath, jobUuid, signal).then((data) => {
        // Set jobs in useBuildStore
        useBuildStore.getState().setJobs(data.jobWithRetries);

        // Set job-drawer data for all returned jobs
        data.jobWithRetries.forEach((job: Job) => {
          if (job.id !== jobUuid) {
            queryClient.setQueryData(jobDrawerQueryKey(build, job.id), {
              job,
              jobWithRetries: data.jobWithRetries,
            });
          }

          // Populate job data
          setJobQueryData(build, job, queryClient);
        });

        return data;
      }),
    ...queryOptionsArgs,
  });
};

function fetchJobDrawer(
  buildDataBasePath: Build["buildDataBasePath"],
  jobUuid: Job["id"],
  signal: AbortSignal,
) {
  const url = new URL(
    `${buildDataBasePath}/jobs/${jobUuid}?include_retries=true`,
    window.location.origin,
  );

  return fetcher<FetchBuildJobResponse>(url, true, { signal });
}
